<template>
    <va-create-layout>
        <FinancialTransactionSummary-form
            :title="title"
            :item="item"
        ></FinancialTransactionSummary-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
